<template>
    <v-dialog
        v-model="display"
        width="500"
        persistent
        >
        <v-card>
            <v-card-title>{{ title }}</v-card-title>
            <v-card-subtitle>{{ $t("JOBCARD_SUBTITLE") }}</v-card-subtitle>
            <v-card-text>
                <div class="text-center">
                    <v-progress-circular
                        indeterminate
                        v-if="!dataLoaded"
                        color="primary">
                    </v-progress-circular>
                </div>
                <v-form
                    ref="form"
                    v-model="valid"
                    v-if="dataLoaded"
                    >
                        <!-- <v-select
                        label="الورشة"
                        :items="workshops"
                        item-text="name"
                        item-value="id"
                        v-model="form.workshop_id"
                        :rules="rules.workshop_id"
                        :disabled="uneditableField('workshop_id')"
                        ></v-select> -->
                    <v-menu
                        v-model="dateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="form.date_enter"
                                :label="$t('JOBCARDS_DATE_ENTER')"
                                prepend-icon="mdi-calendar-month"
                                readonly
                                v-on="on"
                                :rules="rules.date_enter"
                            ></v-text-field>
                        </template>
                        <v-date-picker 
                            v-model="form.date_enter"
                            @input="dateMenu = false"
                            :disabled="uneditableField('date_enter')">
                        </v-date-picker>
                    </v-menu>
                    <v-menu
                        ref="timeEnterMenu"
                        v-model="menu.time_enter"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="form.time_enter"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="form.time_enter"
                                    :label="$t('JOBCARD_TIME_ENTER')"
                                    prepend-icon="mdi-clock"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                                </template>
                        <v-time-picker
                            v-if="menu.time_enter"
                            v-model="form.time_enter"
                            full-width
                            @click:minute="$refs.timeEnterMenu.save(form.time_enter)">
                        </v-time-picker>
                    </v-menu>
                    <v-text-field
                        :readonly="!!form.truck_id"
                        @blur="!form.truck_id ? form.truck_name = null : null"
                        :clearable="true"
                        @click:clear="form.truck_id = null"
                        :label="$t('JOBCARDS_PLATE')"
                        v-model="form.truck_name"
                        :rules="rules.truck_name"
                        :disabled="uneditableField('truck_id')"
                        @keypress.enter="openTruckSearchDialog">
                        <template v-slot:append>
                          <v-icon @click="openTruckSearchDialog">{{ form.truck_id ? '' :'mdi-magnify' }}</v-icon>
                        </template>
                    </v-text-field>
                     <v-text-field
                        :readonly="!!form.driver_id"
                        @blur="!form.driver_id ? form.driver_name = null : null"
                        :clearable="true"
                        :append-icon="form.driver_id ? '' : 'mdi-magnify'"
                        @click:clear="form.driver_id = null"
                        :label="$t('JOBCARD_DRIVER')"
                        v-model="form.driver_name"
                        :disabled="uneditableField('driver_id')"
                        :rules="rules.driver_name"
                        @keypress.enter="openDriverSearchDialog">
                        <template v-slot:append>
                          <v-icon @click="openDriverSearchDialog">{{ form.driver_id ? '' :'mdi-magnify' }}</v-icon>
                        </template>
                    </v-text-field>
                    <v-text-field
                        :label="$t('JOBCARD_ODOMETER')"
                        v-model="form.odometer"
                        :rules="rules.odometer"
                        :disabled="uneditableField('odometer')"
                        >
                    </v-text-field>

                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    text
                    :disabled="!valid || loading.submit"
                    :loading="loading.submit"
                    @click="submit"
                    >
                    {{ $t('BTN_SAVE') }}
                </v-btn>
                <v-btn
                    text
                    @click="close"
                    >
                    {{ $t("BTN_CANCEL") }}
                </v-btn>
            </v-card-actions>
        </v-card>
        <DriverDialog
            ref="driverDialog"
            @record="selectAddedDriver"/>
        <TruckDialog 
            ref="truckDialog"
            @record="selectAddedTruck"/>
        <AlertDialog
            ref="alertDialog"/>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
        <DriverSearchDialog
            @submit="fillDriverField"
            ref="dirverSreachDailog"/>
        <TruckSearchDialog
            @submit="fillTruckField"
            ref="truckSearchDialog"/>
        <JobcardDisplayDialog
            ref="jobcardDisplayDialog"/>
    </v-dialog>
</template>

<script>
import inArray from '../utils/inArray';
import DriverSearchDialog from '@/components/JobCard/DriverSearchDialog';
import TruckSearchDialog from '@/components/JobCard/TruckSearchDialog';
import DriverDialog from '../components/DriverDialog';
import TruckDialog from '../components/TruckDialog';
import AlertDialog from '../components/AlertDialog';
import RetryDialog from '../components/RetryDialog';
import JobcardDisplayDialog from '@/components/JobcardDisplayDialog';
import { mapActions, mapState } from 'vuex';
import moment from 'moment';
export default {
    name: "JobCardDialog",
    components: {
        DriverDialog,
        TruckDialog,
        AlertDialog,
        RetryDialog,
        DriverSearchDialog,
        TruckSearchDialog,
        JobcardDisplayDialog
    },
    data() {
        return {
            valid: false,
            display: false,
            editMode: false,
            dateMenu: false,
            dataLoaded: false,
            id: null,
            form: {
                driver_name: null,
                date_enter: null,
                time_enter: null,
                workshop_id: null,
                driver_id: null,
                truck_id: null,
                truck_name: null,
                odometer: ''
            },
            rules: {
                workshop_id: [
                    v => !!v || this.$t("RULES_REQUIRED_MSG")
                ],
                date_enter: [
                    v => !!v || this.$t("RULES_REQUIRED_MSG")
                ],
                time_enter: [
                    v => !!v || this.$t("RULES_REQUIRED_MSG")
                ],
                driver_name: [
                    v => !!v || this.$t("RULES_REQUIRED_MSG")
                ],
                truck_name: [
                    v => !!v || this.$t("RULES_REQUIRED_MSG")
                ],
                odometer: [
                    v => v ? !isNaN(v) || this.$t("RULES_NUMERIC_MSG") : true
                ]
            },
            menu: {
                time_enter: null
            },
            loading: {
                submit: false
            }
        }
    },
    computed: {
        ...mapState("workshop", ["workshops"]),
        ...mapState("jobcard", ["jobcard"]),
        ...mapState("authentication", ["loggedInUser", "workshopId", "authorizations"]),
        title() {
            if(!this.editMode) return this.$t("JOBCARD_TITLE_CREATE");
            else return this.$t("JOBCARD_TITLE_UPDATE")
        }
    },
    methods: {
        ...mapActions("workshop", ["fetchAll"]),
        ...mapActions("jobcard", ["storeJobcard", "fetchJobcards", "updateJobcard", "fetchJobcard"]),
        async open(params) {
            this.editMode = params.editMode;
            this.display = true;
            this.form.date_enter = new moment().format("YYYY-MM-DD");
            this.form.time_enter = new moment().format("HH:mm");
            this.form.workshop_id = this.workshopId;
            this.id = params.id;
            this.openDataFetch();
        },
        async openDataFetch() {
            try {
                if(this.editMode) {
                    await this.fetchJobcard(this.id);
                    this.form = this.jobcard;
                }
                this.dataLoaded = true;
            } catch (error) {
                let message = null;
                if(error.response) message = error.response.data.message;
                else message = error;
                this.$refs.retryDialog.open({target: "openDataFetch", message});
            }
        },
        onRetryDialogSubmit(params) {
            if(params.target == "openDataFetch") {
                if(params.retry == true) this.openDataFetch();
                else this.close();
            }
        },
        fillTruckField(params) {
            this.form.truck_id = params.id;
            this.form.truck_name = params.plate_and_type;
        },
        fillDriverField(params) {
            this.form.driver_id = params.id;
            this.form.driver_name = params.name;
        },
        close() {
            this.display = false;
            this.loading.submit = false;
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
            this.dataLoaded = false;
            this.form.truck_id = null;
            this.form.driver_id = null;
        },
        openTruckSearchDialog() {
            this.$refs.truckSearchDialog.open(this.form.truck_name);
        },
        openDriverSearchDialog() {
            this.$refs.dirverSreachDailog.open(this.form.driver_name);
        },
        openDriverDialog(params) {
            this.$refs.driverDialog.open(params);
        },
        selectAddedDriver(record) {
            this.form.driver_id = record.id;
        },
        openTruckDialog(params) {
            this.$refs.truckDialog.open(params);
        },
        selectAddedTruck(record) {
            this.form.truck_id = record.id
        },
        submit() {
            this.loading.submit = true;
            if(!this.editMode) {
                this.storeJobcard(this.form)
                    .then(async response => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t("SUCCESS_TITLE"), this.$t("RECORD_SAVE_SUCCESS"));
                        this.$refs.jobcardDisplayDialog.open({ id: response.record.id })
                    })
                    .catch(error => {
                        this.loading.submit = false;
                        let message = error.response ? error.response.data.message : error;
                        this.$refs.alertDialog.open(this.$t("ERROR_TITLE"), message);
                    });
            } else {
                this.updateJobcard({form: this.form, id: this.id})
                    .then(() => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t("SUCCESS_TITLE"), this.$t("RECORD_UPDATE_SUCCESS"));
                        this.fetchJobcards({workshop_id: this.workshopId, state: "OPEN"});
                    })
                    .catch(error => {
                        this.loading.submit = false;
                        let message = error.response ? error.response.data.message : error;
                        this.$refs.alertDialog.open(this.$t("ERROR_TITLE"), message);
                    });
            }
        },
        inArray,
        uneditableField(field) {
            return this.form.meta && inArray(field, this.form.meta.uneditable_fields) && this.editMode;
        }
    }
}
</script>